import React from 'react';
import Locale from '../../domain/Locale';
import Color from '../../domain/Color';
import SponsorDomain from '../../domain/Sponsor';
import Layout from '../../components/Layout';
import Sponsor from '../../components/Sponsor';
import LoginHeader from '../../components/header/Login';
import LoginContent from '../../components/content/Login';
import { t, props } from 'tcomb-react';

@props({
  locale: Locale,
  message: t.maybe(t.ReactElement),
  themeBtnColor: t.maybe(Color),
  themeBgColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color),
  themeBtnFontColor: t.maybe(Color),
  sponsor: t.maybe(SponsorDomain),
  goResendPassword: t.Func,
  doLogin: t.Func,
  goFacebook: t.Func,
  goGoogle: t.Func,
  goTwitter: t.Func,
  goMicrosoft: t.Func,
  doAcceptCookies: t.Func,
  goRegister: t.maybe(t.Func),
  goProduct: t.maybe(t.Func),
  partners: t.maybe(t.Obj)
})
export default class Login extends React.Component {

  getBgColor() {
    if (!this.props.sponsor) {
      return null;
    }
    return this.props.sponsor.bg_color;
  }

  getColor() {
    if (!this.props.sponsor) {
      return null;
    }
    return this.props.sponsor.color;
  }

  getHeader() {
    return (
      <LoginHeader
        locale={this.props.locale}
        goRegister={this.props.goRegister}
        goProduct={this.props.goProduct}
        color={this.getColor()}
        themeBtnColor={this.props.themeBtnColor}
        themeBtnFontColor={this.props.themeBtnFontColor} />
    );
  }

  getSponsor() {
    const options = {
      showTutorial: false
    };
    return (<Sponsor sponsor={this.props.sponsor} locale={this.props.locale} options={options} />);
  }

  render() {
    const locale = this.props.locale;
    return (
      <Layout header={this.getHeader()} partners={this.props.partners}  sponsor={this.getSponsor()} bgColor={this.getBgColor()} locale={locale} doAcceptCookies={this.props.doAcceptCookies}>
        <LoginContent
          locale={locale}
          message={this.props.message}
          themeBgColor={this.props.themeBgColor}
          themeBtnColor={this.props.themeBtnColor}
          themeBgFontColor={this.props.themeBgFontColor}
          themeBtnFontColor={this.props.themeBtnFontColor}
          doLogin={this.props.doLogin}
          goResendPassword={this.props.goResendPassword}
          goFacebookLogin={this.props.goFacebook}
          goGoogleLogin={this.props.goGoogle}
          goTwitterLogin={this.props.goTwitter}
          goMicrosoftLogin={this.props.goMicrosoft} />
      </Layout>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/product/route/Login.js
 **/